import { gql, useMutation } from '@apollo/client';
import { Pda } from './components/Pda';
import { Header } from './components/Header';
import { HandleScanEventResult, VehicleRelatedScanComponent } from './components/VehicleRelatedScanComponent';
import { t } from '../../i18n';


const HANDLE_WHS_SEALED_SCAN_EVENT = gql`
mutation HandleWhsSealedScanEvent($licensePlate: String!, $sealNo: String!) {
  success: handleWhsSealedScanEvent(licensePlate: $licensePlate, sealNo: $sealNo)
}
`

const PageBody = () => {

  const [handleWhsSealedScanEvent] = useMutation<HandleScanEventResult>(HANDLE_WHS_SEALED_SCAN_EVENT);

  const handleScanEvent = async (value1: string, value2: string): Promise<HandleScanEventResult> => {
    if (value1 === "" || value2 === "") {
      return {success: false};
    }
    const {data} = await handleWhsSealedScanEvent({ variables: { licensePlate: value1, sealNo: value2 } });
    return {success: data?.success || false};
  };

  return (
    <VehicleRelatedScanComponent
      value1Placeholder={t('pda.pages.sealed.licensePlate')}
      value2Placeholder={t('pda.pages.sealed.sealNO.')}
      value1ColumnTitle={t('pda.pages.sealed.licensePlate')}
      value2ColumnTitle={t('pda.pages.sealed.sealNO.')}
      isCheckBarCodeValid={false}
      handleScanEvent={handleScanEvent}
    />
  );
}

export default function SealedPage() {
  return (
    <div className="w-full h-full flex flex-col gap-2 p-2">
      <Header title={t('pda.pages.sealed.sealedScan')} />
      <Pda />
      <PageBody />
    </div>
  );
}